// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout_content__2GYk4","layout":"Layout_layout__1P4E1"};